const mediaTypes = [
  {
    type: "video/ogg",
    exts: ["ogg", "ogg", "ogv", "oga", "ogx", "ogm", "spx", "opus"]
  },
  {
    type: "video/mp4",
    exts: ["mp4", "m4a", "m4b", "m4p", "m4r", "m4v"]
  },
  {
    type: "video/webm",
    exts: ["webm"]
  }
];

export function getVideoMediaTypeForPath(path) {
  const extension = path.substr(path.lastIndexOf(".") + 1);
  const mediaType = mediaTypes.find(m => m.exts.includes(extension));

  return (mediaType && mediaType.type) || "";
}
